/**
 * Build a SQLite FTS5 MATCH expression from a user search string.
 * Terms are ANDed; quoted phrases are preserved.
 */

const WHITESPACE = /\s+/;

/** Split a query into terms, respecting double-quoted phrases. */
export function tokenizeSearchQuery(query: string): string[] {
  const trimmed = query.trim();
  if (!trimmed) {
    return [];
  }

  const tokens: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < trimmed.length; i += 1) {
    const char = trimmed[i]!;
    if (char === '"') {
      if (inQuotes) {
        if (current.length > 0) {
          tokens.push(current);
          current = '';
        }
        inQuotes = false;
      } else {
        if (current.trim().length > 0) {
          for (const part of current.trim().split(WHITESPACE)) {
            if (part.length > 0) {
              tokens.push(part);
            }
          }
          current = '';
        }
        inQuotes = true;
      }
      continue;
    }

    if (!inQuotes && WHITESPACE.test(char)) {
      if (current.trim().length > 0) {
        tokens.push(current.trim());
        current = '';
      }
      continue;
    }

    current += char;
  }

  if (current.trim().length > 0) {
    tokens.push(current.trim());
  }

  return tokens.filter((token) => token.length > 0);
}

function escapeFtsToken(token: string): string {
  return `"${token.replace(/"/g, '""')}"`;
}

/** Returns null when the query has no searchable tokens. */
export function buildFtsMatchQuery(query: string): string | null {
  const tokens = tokenizeSearchQuery(query);
  if (tokens.length === 0) {
    return null;
  }
  return tokens.map(escapeFtsToken).join(' AND ');
}
